__turbopack_context__.v({
  "checkbox": "checkboxField-module-scss-module__kMq64G__checkbox",
  "checkboxContainer": "checkboxField-module-scss-module__kMq64G__checkboxContainer",
  "container": "checkboxField-module-scss-module__kMq64G__container",
  "error-msg": "checkboxField-module-scss-module__kMq64G__error-msg",
  "errorContainer": "checkboxField-module-scss-module__kMq64G__errorContainer",
  "errorContent": "checkboxField-module-scss-module__kMq64G__errorContent",
  "errorIcon": "checkboxField-module-scss-module__kMq64G__errorIcon",
  "hint": "checkboxField-module-scss-module__kMq64G__hint",
  "label": "checkboxField-module-scss-module__kMq64G__label",
  "label-disabled": "checkboxField-module-scss-module__kMq64G__label-disabled",
  "required": "checkboxField-module-scss-module__kMq64G__required",
  "svg": "checkboxField-module-scss-module__kMq64G__svg",
  "textContainer": "checkboxField-module-scss-module__kMq64G__textContainer",
});
